import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/storage';

const firebaseConfig = {
	apiKey : 'AIzaSyD5r51_6Ybf_w28tL0C7R5KzM94iFvvoDs',
	authDomain : 'muhsd-course-catalog.firebaseapp.com',
	databaseURL : 'https://muhsd-course-catalog.firebaseio.com',
	projectId : 'muhsd-course-catalog',
	storageBucket : 'muhsd-course-catalog.appspot.com',
	messagingSenderId : '169887225472',
	appId : '1:169887225472:web:9e7a31473e2467c2e4f865'
};
if ( !firebase.apps.length ) {
	firebase.initializeApp( firebaseConfig );
}
export default firebase;
